import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import { Site } from '../../../../common/types';

type ForcedStoreSelectionProps = {
  sites: Site[];
  onSiteSelected: (site: Site) => void;
  title?: string;
  subtitle?: string;
};

export default function ForcedStoreSelection({
  sites,
  onSiteSelected,
  title = 'Welcome to TPGE!',
  subtitle = 'Please select a store to view the menu and start your order.',
}: ForcedStoreSelectionProps) {
  const theme = useTheme();

  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      onClose={() => { }} // Forced selection, no close
    >
      <Stack sx={{ padding: 2 }} spacing={2}>
        <Stack spacing={1}>
          <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            {subtitle}
          </Typography>
        </Stack>

        <List sx={{ pt: 1 }}>
          {sites.map((site) => (
            <ListItem
              key={site.id}
              disablePadding
              sx={{
                mb: 1.5,
                backgroundColor: 'white',
                borderRadius: 1,
                border: `1px solid ${theme.palette.divider}`
              }}
            >
              <ListItemButton
                onClick={() => onSiteSelected(site)}
                sx={{ padding: 1.5, borderRadius: 1 }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: theme.palette.common.darkGrey }}>
                    <LocationOnOutlined
                      sx={{ color: theme.palette.common.utilityOrange }}
                    />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={site.name}
                  primaryTypographyProps={{ variant: 'subtitle1', fontWeight: 'bold' }}
                  secondary={site.state}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {sites.length === 0 && (
          <Typography variant="body1" sx={{ textAlign: 'center', mt: 2 }}>
            Loading stores...
          </Typography>
        )}
      </Stack>
    </Dialog>
  );
}
